import initStickyCategories from "../shared/sticky-categories";

document.addEventListener("DOMContentLoaded", function () {
    initStickyCategories();

    const modalEl = document.getElementById("productModal");
    const bsModal = modalEl ? new bootstrap.Modal(modalEl) : null;
    const getModal = () =>
        new bootstrap.Modal(document.getElementById("checkoutModal"));

    window.addEventListener("open-product-modal", () => {
        if (bsModal) bsModal.show();
    });

    window.addEventListener("close-product-modal", () => {
        if (bsModal) bsModal.hide();
    });

    const Toast = Swal.mixin({
        toast: true,
         position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });

    window.addEventListener("alert", ({ detail: { type, message } }) => {
        Toast.fire({
            icon: type,
            title: message,
        });
    });

    // --- Carrito: feedback optimista (agregar se siente instantáneo) ---
    // La FUENTE DE VERDAD sigue siendo el servidor (Livewire actualiza la sesión
    // y re-renderiza el drawer + los badges). Esto sólo ADELANTA el feedback
    // visual a 0 ms; el re-render de Livewire reconcilia los badges al valor real.
    function bumpCartBadges() {
        document
            .querySelectorAll(
                ".badge-cart, .cart-drawer__count, .catalog-cart-fab__badge"
            )
            .forEach((el) => {
                const raw = (el.textContent || "").trim();
                if (raw.indexOf("+") !== -1) return; // formato "99+": lo corrige el servidor
                const n = parseInt(raw, 10);
                if (Number.isNaN(n)) return;
                const next = n + 1;
                el.textContent =
                    el.classList.contains("catalog-cart-fab__badge") && next > 99
                        ? "99+"
                        : String(next);
            });

        const fab = document.querySelector(".catalog-cart-fab");
        if (fab && typeof fab.animate === "function") {
            fab.animate(
                [
                    { transform: "scale(1)" },
                    { transform: "scale(1.18)" },
                    { transform: "scale(1)" },
                ],
                { duration: 280, easing: "ease-out" }
            );
        }
    }

    // Captura en fase de captura para correr ANTES de que Livewire procese el clic.
    document.addEventListener(
        "click",
        function (e) {
            const btn = e.target.closest("button[wire\\:click]");
            if (!btn || btn.disabled) return;

            const action = btn.getAttribute("wire:click") || "";
            // Sólo el "Agregar" directo del grid (productos sin variantes).
            // No matchea openDetail(), addSelectedToCart(), incrementQty(), etc.
            if (action.indexOf("addToCart(") !== 0) return;

            bumpCartBadges();
            window.dispatchEvent(
                new CustomEvent("alert", {
                    detail: { type: "success", message: "Agregado al carrito" },
                })
            );
        },
        true
    );

    window.addEventListener("open-checkout", () => {
        getModal().show();
    });

    window.addEventListener("close-checkout", () => {
        const el = document.getElementById("checkoutModal");
        const instance = bootstrap.Modal.getInstance(el);
        if (instance) instance.hide();
    });

    window.addEventListener("open-whats", (e) => {
        const url = e.detail?.url;
        if (!url) return;

        window.location.assign(url);
    });

    function showWhatsFallback(url) {
        let box = document.getElementById("whats-fallback");
        if (!box) {
            box = document.createElement("div");
            box.id = "whats-fallback";
            box.style.cssText = `
      position: fixed; left: 16px; right: 16px; bottom: 16px;
      padding: 14px; border-radius: 12px; background: #fff;
      box-shadow: 0 8px 24px rgba(0,0,0,.18); z-index: 99999;
      font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial;
    `;
            box.innerHTML = `
      <div style="display:flex; gap:12px; align-items:center; justify-content:space-between; flex-wrap:wrap;">
        <div style="font-size:14px; line-height:1.3;">
          <b>Abrir WhatsApp</b><br>
          Si no se abrió automáticamente, toca el botón:
        </div>
        <div style="display:flex; gap:8px;">
          <a id="whats-fallback-link"
             target="_blank" rel="noopener noreferrer"
             style="background:#111; color:#fff; padding:10px 12px; border-radius:10px; text-decoration:none;">
            Abrir WhatsApp
          </a>
          <button id="whats-fallback-close"
             style="background:#eee; padding:10px 12px; border-radius:10px; border:0; cursor:pointer;">
            Cerrar
          </button>
        </div>
      </div>
      <div style="margin-top:10px; font-size:12px; color:#555;">
        Tip: permite pop-ups para este sitio si quieres que se abra automático.
      </div>
    `;
            document.body.appendChild(box);
            document.getElementById("whats-fallback-close").onclick = () =>
                box.remove();
        }

        document.getElementById("whats-fallback-link").href = url;
    }

    document.addEventListener("click", function (e) {
        const btnMobile = e.target.closest(".pagination-scroll-top");
        const btnLivewire = e.target.closest(
            ".pagination .page-link, .pagination .page-item button"
        );

        if (!btnMobile && !btnLivewire) return;

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
});

// Ficha de producto: compartir y scroll de recomendados
window.ppShare = function (btn) {
    const url = btn.dataset.url;
    const title = btn.dataset.title || document.title;
    if (navigator.share) {
        navigator.share({ title, url }).catch(() => {});
    } else {
        navigator.clipboard.writeText(url).then(() => {
            window.dispatchEvent(
                new CustomEvent("alert", {
                    detail: { type: "success", message: "Link copiado" },
                })
            );
        });
    }
};

window.ppRecsScroll = function (px) {
    const s = document.getElementById("ppRecsStrip");
    if (s) s.scrollBy({ left: px, behavior: "smooth" });
};
